import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';

import '@/components/accept-terms';
import '@/components/cards';
import '@/components/carousels';
import '@/components/inputs';
import '@/components/tables';
import '@/components/graphics';
import '@/components/html';
import '@/components/title';
import '@/components/list-email';
import '@/components/buttons';
import '@/components/ecm';
import '@/components/dev';
import '@/components/flexmonster';
import '@/components/markdown';
import '@/components/timeline';

Vue.use(VueFormGenerator);
